import { render } from "./PropertyInput.vue?vue&type=template&id=47d001a0"
import script from "./PropertyInput.vue?vue&type=script&lang=js"
export * from "./PropertyInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__